import {useStepperPaths} from './useStepperPaths'

export const usePreviousStepperPath = (currentPath: string): string => {
  const stepperPaths = useStepperPaths()

  const currentPathIndex = stepperPaths.findIndex((path) => currentPath === path)

  if (currentPathIndex === -1) {
    return stepperPaths[0]
  }

  const previousPathIndex = currentPathIndex - 1

  const previousPath = stepperPaths[previousPathIndex]

  if (!previousPath) {
    return stepperPaths[0]
  }

  return previousPath
}
